import moment from "moment";
import "moment/locale/pt-br";
import { createContext, useState } from "react";

const DashBoardContext = createContext();

const DashBoardContextProvider = ({ children }) => {
  const [dashBoardModulesInfo, setDashBoardModulesInfo] = useState({
    financeiro: {
      viewPermission: false,
      verifyedPermissions: false,
      hiddenAccordionSumary: false,
    },
  });
  const [loading, setLoading] = useState({
    general: false,
    filtro: false,
    financeiro: false,
  });
  const [expanded, setExpanded] = useState({ filtro: false, financeiro: true });

  const [isFilterModalOpen, setIsFilterModalOpen] = useState(false);

  const initialStartDate = moment().startOf("month").format("YYYY-MM-DD");
  const initialEndDate = moment().endOf("month").format("YYYY-MM-DD");
  const initialYear = moment().year();

  const [yearPeriod, setYearPeriod] = useState(initialYear);
  const [customStartDate, setCustomStartDate] = useState(initialStartDate);
  const [customEndDate, setCustomEndDate] = useState(initialEndDate);

  const [dashBoardFilters, setDashBoardFilters] = useState({
    startDate: initialStartDate,
    endDate: initialEndDate,
  });

  const [showSelectAnualQuarter, setShowSelectAnualQuarter] = useState(false);
  const [showSelectMonth, setShowSelectMonth] = useState(false);
  const [anualQuarter, setAnualQuarter] = useState(null);
  const [month, setMonth] = useState(null);
  const [companies, setCompanies] = useState([]);

  const defaultTypePeriodList = [
    {
      label: "Este Mês",
      id: "EM",
      actualYear: true,
      getStartDate: () => {
        return moment().startOf("month").format("YYYY-MM-DD");
      },
      getEndDate: () => {
        return moment().endOf("month").format("YYYY-MM-DD");
      },
    },
    {
      label: "Hoje",
      id: "H",
      actualYear: true,
      getStartDate: () => {
        return moment().format("YYYY-MM-DD");
      },
      getEndDate: () => {
        return moment().format("YYYY-MM-DD");
      },
    },
    {
      label: "Mês Anterior",
      id: "MA",
      actualYear: true,
      getStartDate: () => {
        return moment()
          .subtract(1, "month")
          .startOf("month")
          .format("YYYY-MM-DD");
      },
      getEndDate: () => {
        return moment()
          .subtract(1, "month")
          .endOf("month")
          .format("YYYY-MM-DD");
      },
    },
    {
      label: "Próximo Mês",
      id: "PM",
      actualYear: true,
      getStartDate: () => {
        return moment().add(1, "month").startOf("month").format("YYYY-MM-DD");
      },
      getEndDate: () => {
        return moment().add(1, "month").endOf("month").format("YYYY-MM-DD");
      },
    },
    {
      label: "Trimestral",
      id: "T",
      actualYear: false,
      getStartDate: () => {
        return null;
      },
      getEndDate: () => {
        return null;
      },
    },
    {
      label: "Mensal",
      id: "M",
      actualYear: false,
      getStartDate: () => {
        return null;
      },
      getEndDate: () => {
        return null;
      },
    },
    {
      label: "Anual",
      id: "A",
      actualYear: false,
      getStartDate: (customYear) => {
        return moment(`${customYear}-01-01`)
          .startOf("year")
          .format("YYYY-MM-DD");
      },
      getEndDate: (customYear) => {
        return moment(`${customYear}-01-01`).endOf("year").format("YYYY-MM-DD");
      },
    },
    {
      label: "Personalizado",
      id: "P",
      actualYear: false,
      getStartDate: () => {
        return null;
      },
      getEndDate: () => {
        return null;
      },
    },
  ];

  const [typePeriod, setTypePeriod] = useState(defaultTypePeriodList[0]);
  const [typePeriodList, setTypePeriodList] = useState(defaultTypePeriodList);

  const anualQuarterList = [
    {
      label: "Janeiro a Março",
      id: 1,
      getStartDate: (customYear = yearPeriod) => {
        return moment(`${customYear}-01-01`).format("YYYY-MM-DD");
      },
      getEndDate: (customYear = yearPeriod) => {
        return moment(`${customYear}-03-01`)
          .endOf("month")
          .format("YYYY-MM-DD");
      },
    },
    {
      label: "Abril a Junho",
      id: 2,
      getStartDate: (customYear = yearPeriod) => {
        return moment(`${customYear}-04-01`).format("YYYY-MM-DD");
      },
      getEndDate: (customYear = yearPeriod) => {
        return moment(`${customYear}-06-01`)
          .endOf("month")
          .format("YYYY-MM-DD");
      },
    },
    {
      label: "Julho a Setembro",
      id: 3,
      getStartDate: (customYear = yearPeriod) => {
        return moment(`${customYear}-07-01`).format("YYYY-MM-DD");
      },
      getEndDate: (customYear = yearPeriod) => {
        return moment(`${customYear}-09-01`)
          .endOf("month")
          .format("YYYY-MM-DD");
      },
    },
    {
      label: "Outubro a Dezembro",
      id: 4,
      getStartDate: (customYear = yearPeriod) => {
        return moment(`${customYear}-10-01`).format("YYYY-MM-DD");
      },
      getEndDate: (customYear = yearPeriod) => {
        return moment(`${customYear}-12-01`)
          .endOf("month")
          .format("YYYY-MM-DD");
      },
    },
  ];

  const monthList = [];
  moment.months().forEach((monthName, index) => {
    const getMonth = (month) => {
      month += 1;
      if (month > 9) return month;
      return `0${month}`;
    };
    monthList.push({
      label: monthName.charAt(0).toUpperCase() + monthName.slice(1),
      id: index + 1,
      getStartDate: (customYear = yearPeriod) => {
        return moment(`${customYear}-${getMonth(index)}-01`).format(
          "YYYY-MM-DD"
        );
      },
      getEndDate: (customYear = yearPeriod) => {
        return moment(`${customYear}-${getMonth(index)}-01`)
          .endOf("month")
          .format("YYYY-MM-DD");
      },
    });
  });

  const defaultIntervalPeriodLabel = {
    day: {
      strInfo: `Dia / Mês (Respectivo ao ano de ${yearPeriod})`,
      strDateFormat: "DD/MM",
    },
    date: {
      strInfo: `Dia / Mês (Respectivo ao ano de ${yearPeriod})`,
      strDateFormat: "DD/MM",
    },
    week: {
      strInfo: `Dia / Mês (Respectivo ao ano de ${yearPeriod})`,
      strDateFormat: "DD/MM",
    },
    month: {
      strInfo: "Mês / Ano",
      strDateFormat: "MM/YYYY",
    },
  };

  return (
    <DashBoardContext.Provider
      value={{
        yearPeriod,
        setYearPeriod,
        typePeriodList,
        setTypePeriodList,
        loading,
        setLoading,
        typePeriod,
        setTypePeriod,
        expanded,
        setExpanded,
        isFilterModalOpen,
        setIsFilterModalOpen,
        customStartDate,
        setCustomStartDate,
        customEndDate,
        setCustomEndDate,
        showSelectAnualQuarter,
        setShowSelectAnualQuarter,
        showSelectMonth,
        setShowSelectMonth,
        anualQuarter,
        setAnualQuarter,
        month,
        setMonth,
        companies,
        setCompanies,
        dashBoardModulesInfo,
        setDashBoardModulesInfo,
        dashBoardFilters,
        setDashBoardFilters,
        defaultTypePeriodList,
        anualQuarterList,
        monthList,
        defaultIntervalPeriodLabel,
      }}
    >
      {children}
    </DashBoardContext.Provider>
  );
};

export { DashBoardContextProvider, DashBoardContext };
